import root from 'window-or-global';

const defaultLocale = 'en-US';

export const setLocale = (newLocale: string) => {
    if (!newLocale) return;
    root.__epic_common_locale = newLocale;
};

export const getLocale = (): string => {
    return root.__epic_common_locale || defaultLocale;
};

export const getOgLocale = (): string => {
    let locale = getLocale();
    if (locale.indexOf('-') !== -1) {
        locale = locale.replace('-', '_');
    }
    return locale;
};
